/* src/app/invoice/register/invoice-register-filters-presenter/invoice-register-filters-presenter.component.scss */
/*# sourceMappingURL=invoice-register-filters-presenter.component.css.map */
